import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { CopyrightPage } from '@/pages/CopyrightPage';

export const copyrightRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/copyright',
  component: CopyrightPage,
});
